const ENV = process.env.ENV.TARGET_ENV;

let _apiBaseUrl = '';

switch (ENV) {
  case 'local':
    _apiBaseUrl = 'https://dev.homexin.com.tw';
    break;

  case 'prod':
    _apiBaseUrl = 'https://api.homexin-hub.com';
    break;

  case 'dev':
    _apiBaseUrl = 'https://dev.homexin.com.tw';
    break;

  default:
    _apiBaseUrl = '';
    break;
}

const apiBaseUrl = _apiBaseUrl;

export default apiBaseUrl;
